import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router';
import test from '../pages/TestPage.vue';
// 2. 配置路由
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'dashboard',
        component: test,
        children: [
            {
                path: '/',
                component: () => import('../pages/TestPage2.vue')
            },
            {
                path: '/3/:parentId/:index',
                name: '3',
                component: () => import('../pages/TestPage3.vue')
            },
            {
                path: '/4/:parentId/:index',
                name: '4',
                component: () => import('../pages/TestPage4.vue')
            },
            {
                path: '/5/:parentId/:index',
                name: '5',
                component: () => import('../pages/TestPage5.vue')
            },
            {
                path: '/6/:parentId/:index',
                name: '6',
                component: () => import('../pages/TestPage6.vue')
            },
            {
                path: '/7/:parentId/:index',
                name: '7',
                component: () => import('../pages/TestPage7.vue')
            },
            {
                path: '/jcsk/:parentId/:index',
                name: 'jcsk',
                component: () => import('../pages/jcsk.vue')
            },
            {
                path: '/view',
                name: 'view',
                component: () => import('../pages/views/view.vue')
            },
            {
                path: '/qrcode',
                name: 'qrcode',
                component: () => import('../pages/views/qrcode.vue')
            },
            {
                path: '/more/:modularId/:modularName/:mode',
                name: 'more',
                component: () => import('../pages/views/more.vue')
            },
            {
                path: '/hypx/:parentId/:index',
                name: 'hypx',
                component: () => import('../pages/hypx.vue')
            },
            {
                path: '/maps',
                name: 'maps',
                component: () => import('../pages/maps/maps.vue')
            }
        ]
    }
];
// 1.返回一个 router 实列，为函数，里面有配置项（对象） history
const router = createRouter({
    history: createWebHashHistory(),
    routes
});

export default router;
